export default __webpack_public_path__ + "static/media/goopter-bellabot-specifications.b3b44b61.png";